import { createFileRoute, redirect } from "@tanstack/react-router"

import { LINKS } from "../../../../routing/links"

export const Route = createFileRoute("/$sessionId/_session/documents/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: LINKS.documentsIntro(params.sessionId) })
  },
})
